import React, {useEffect} from 'react';
import {View, Dimensions, StyleSheet} from 'react-native';
import HomeHeader from '../../components/HomeHeader';
import {Card, Text} from 'react-native-elements';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export default function ComplaintDetailsScreen(props) {

  useEffect(() => {}, []);

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation} />
      <View style={styles.container}>
        <Card
          containerStyle={{
            backgroundColor: '#e10808',
            borderWidth: 0,
            elevation: 10,
            borderRadius: 5,
          }}>
          <Card.Title style={{color: 'white'}}>
            Ticket #{props.route.params.ticketno}
          </Card.Title>
          <Card.Divider />
          <Text style={{marginBottom: 10, color: 'white', fontSize: 16}}>
            {props.route.params.opening}
          </Text>
          <Text style={{marginBottom: 10, color: 'orange', fontSize: 16}}>
            {props.route.params.closing}
          </Text>
        </Card>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT
  },
  indicatorStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  container: {
    flex: 1
  },
  content:{
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 2,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  }
});